<template>

    <div class="">
        
        <div class="row" >
                <div class="col-md-6 p-0">
                    <div class="col-sm-6">
                    <b-form-group id="day_one-group" label="From [YYYY-MM-DD]" label-for="day_one_text">
                        <b-input-group class="mb-3">
                            <b-form-input id="day_one_text" name="day_one_text" v-model="day_one" v-validate="{ required: true }" type="text" placeholder="YYYY-MM-DD" autocomplete="off" @change="updateToDate" :state="validateState('day_one_text')" aria-describedby="day_one_text-feedback" data-vv-as="From Date"></b-form-input>
                            <b-input-group-append>
                                <b-form-datepicker id="day_one" @context="updateToDate()" button-only right locale="en-US" v-model="day_one" ></b-form-datepicker>
                            </b-input-group-append>
                            <b-form-invalid-feedback id="day_one_text-feedback">{{ veeErrors.first('day_one_text') }}</b-form-invalid-feedback>
                        </b-input-group>
                    </b-form-group>
                </div>
                <div class="col-sm-6"> 
                    <b-form-group id="day_two-group" label="To [YYYY-MM-DD]" label-for="day_two_text">
                        <b-input-group class="mb-3">
                            <b-form-input id="day_two_text" name="day_two_text" v-model="day_two" v-validate="{ required: true }" type="text" placeholder="YYYY-MM-DD" autocomplete="off" @change="checkValidDate" :state="validateState('day_two_text')" aria-describedby="day_two_text-feedback" data-vv-as="To Date"></b-form-input>
                            
                            <b-input-group-append>
                                <b-form-datepicker id="day_two" @context="resetView()" button-only right locale="en-US" :min="min"  v-model="day_two" ></b-form-datepicker>
                            </b-input-group-append>

                            <b-form-invalid-feedback id="day_two_text-feedback">{{ veeErrors.first('day_two_text') }}</b-form-invalid-feedback>
                        </b-input-group>
                    </b-form-group>
                </div>
            </div>                            
            
            <div class="col-md-6">
                <div class="row d-flex justify-content-end no-margin">
                    <b-button variant="primary" class="d-flex justify-content-end m-1" @click="previewOrDownloadReport(0)">Preview Report</b-button>
                    <b-button variant="secondary" class="d-flex justify-content-end m-1" @click="previewOrDownloadReport(1)">Download Excel</b-button>
                    <b-button variant="secondary" class="d-flex justify-content-end m-1 btn-warning" @click="resetView()">Reset</b-button>

                </div>
            </div>                        
        </div>
        
        <!-- <div class="container" v-if="this.is_grid_diplayable"> -->
        <div class="container p-0" v-if="this.is_grid_diplayable">
            <template v-if="custom_list.length > 0">
                <div class="font-weight-bold">Select employee(s) below to get the report.</div>
                <common-list-leave-report :checkbox="checkbox" :leave_type_options="this.leave_type_options" :appended_column="appended_column" :key="list_key" :company_options="company_options" :employees="custom_list" :default_column="default_column" :primary_key="primary_key" v-on:childToParent="listReturn"></common-list-leave-report>
            </template>
            <template v-else>
                <div class="font-weight-bold">No data found on that range.</div>
            </template>
        </div>
        <div class="card p-3" v-if="!this.is_grid_diplayable && this.is_preview">
            <h4>Attendance Summary</h4>
            <div class="card-head">
                <h6>For the period  {{formatMe(this.day_one)}} to  {{formatMe(this.day_two)}} </h6>
            </div>
            <div class="card-body container px-0">
                <table class="table">
                    <thead>
                        <th>Name</th>
                        <th>Employee Code</th>
                        <th>Department</th>
                        <th>Designation</th>

                        <th>Total Working Days</th>
                        <th>Present</th>
                        <th>%</th>
                        <th>Absent</th>
                        <th>%</th>
                    </thead>
                    <tbody>                            
                        <tr class="table" v-for="pdata in this.preview_data" :key="pdata.employee_id"> 

                            <td> {{pdata.name}}  </td>
                            <td> {{pdata.employee_code}}  </td>
                            <td> {{pdata.department}}  </td>
                            <td> {{pdata.designation}}  </td>

                            <td> {{pdata.total_working_days_of_employee}}  </td>
                            <td> {{pdata.total_working_day}}  </td>
                            <td> {{pdata.present_percentage}}  </td>
                            <td> {{pdata.absent}}  </td>
                            <td> {{pdata.absent_percentage}}  </td>
                            
                            </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>


<script>
 import moment from 'moment'
    export default{
        
        mounted() {
            
        },
        data(){            
            const now = new Date()
            const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
            // 15th two months prior
            const minDate = new Date(today)
            minDate.setMonth(minDate.getMonth())
            minDate.setDate(minDate.getDate() + 1)
            /*const maxDate = new Date(today)
            maxDate.setMonth(maxDate.getMonth() + 2)
            maxDate.setDate(15)*/

            //minDate = moment(String(minDate)).format('YYYY-mm-dd');
            const startdate = minDate

            //////////////////////////////
            var startDate = '';
            var endDate = '';
            if ((today.getMonth() + 1) <= 6) 
            {                    
                startDate = (today.getFullYear() - 1) + '-07-1';
                endDate = (today.getFullYear()) + '-06-30';
            } 
            else 
            {
                startDate = (today.getFullYear()) + '-07-1';
                endDate = (today.getFullYear() + 1) + '-06-30';
            }
            return {
                
                /**Child Component property data */
                selected: [],
                checkbox:1,
                is_action:1, /* As this list have actions then is_action will be 1. Otherwise it will be 0 */
                list_key:0, /* Component Key */
                custom_list:[],  /* Data List */
                default_column:['name','phone','email','jobposition','department','branch'], /* Default Column List */
                appended_column:[                 
                    /* { value: "text_type_1", text: "Text 1",type: "text"}, */
                ],   
                leave_type_options:[],                /* Appended Column List  and there title and type */
                primary_key:'employee_id',  /* Primary is the unique key of the list this key will be returned if the row is clicked, 
                                            for employee list is employee_id, For loan list it is loan_id etc here it is employee_id*/
                company_options:[],         /* Company Filterable options */

                /***Child Component property data */

                tmp_custom_list:[],

                // new list from nhl 
                startDate : startDate,
                endDate : endDate,


                min: minDate,
                //max: maxDate,
                showoverlay : false,
                //day_one: moment(String(startdate)).format('YYYY-MM-DD') , 
                day_one: startDate , 
                day_two: moment(String(startdate)).format('YYYY-MM-DD') , 

                // new NHL 
                preview_data: '',
                is_preview: 0,
                is_grid_diplayable: 1,
            }
        },
        methods:{
            
            /* This is the child component return funtion. 
            It will return if any row or action is clicked with primary_key and action_id (if any action is clicked otherwise action id will be 0)
            We can then trigger appropriate funtion depending on primary key and action id.
            */
            formatMe(d)
            {
                return moment(d).format('LL');
            },
            updateToDate()
            {
                if(this.fake == 1)return;
                this.day_two = this.day_one;
                this.min = this.day_one;

                this.resetView();
            },
            checkValidDate()
            {
                if(moment(this.day_two).isBefore(moment(this.day_one).format('YYYY-MM-DD')))
                    this.updateToDate();
            },
           validateState(ref)
            {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },
            listReturn:function(data)
            {
                this.selected = data;

            },
            resetView: function()
            { 
                this.is_grid_diplayable = 1;
                this.preview_data = '';
                this.selected = '';
                this.list_key +=1;

                this.getCustomList();

            },
            getCustomList: function()
            { 
               
                if(!this.checkNet()) return false;
                let currentObj = this; 
                
                axios.get(this.$api_url+'/leaveattendancereport/getcustomlist?flg=1&day_one='+this.day_one+'&day_two='+this.day_two , {

                }).then(function(response){

                    /* Assingning the list */ 
                    this.tmp_custom_list = response.data.employee_data;
                    this.leave_type_options = response.data.leave_type_options;
                    /* Assingning the Options */ 
                    this.company_options = response.data.options;

                    /* Now if we have actions in this grid then we have to create an additional key in each row and assing the actions for each row accordingly */
                    if(this.tmp_custom_list.length > 0 )
                    {
                        this.tmp_custom_list.forEach(element => {

                                if(element.leave_type.length>0)
                                {
                                    let types = [];
                                    let type_ids = [];
                                    element.leave_type.forEach(newelement => {

                                        types.push(newelement.value);
                                        type_ids.push(newelement.id);
                                        
                                        });

                                        element.leave_types = types.join(" , ");
                                        element.leave_type_ids = type_ids;
                                }
                                else
                                {
                                    element.leave_types = 'Not Available';
                                    element.leave_type_ids = [];

                                }
                             });
                        
                    }
                    
                    this.custom_list = this.tmp_custom_list;
                    

                    this.list_key = this.list_key + 1;
                }.bind(this)).catch(function (error){currentObj.serverError(error);});

            }, 
            previewOrDownloadReport: function(flg)
            {
                if(!this.checkNet()) return false;
                if (typeof this.selected.selected == 'undefined')
                    this.$bvToast.toast("No employee selected", {title: 'Error!',variant: 'danger',solid: true, toaster: "toaster: b-toaster-top-right"});
                
                else if (this.selected.selected == '')
                    this.$bvToast.toast("No employee selected", {title: 'Error!',variant: 'danger',solid: true, toaster: "toaster: b-toaster-top-right"});
                
                else if (typeof this.day_one == 'undefined')
                    this.$bvToast.toast("No from date selected", {title: 'Error!',variant: 'danger',solid: true, toaster: "toaster: b-toaster-top-right"});
                else if (typeof this.day_two == 'undefined')
                    this.$bvToast.toast("No to date selected", {title: 'Error!',variant: 'danger',solid: true, toaster: "toaster: b-toaster-top-right"});
                else
                {
                    
                    let currentObj = this;
                    this.$bvToast.toast('It might take a while', {
                                            title: `Info`,
                                            variant: 'info',
                                            solid: true 
                                        });
                    this.showoverlay = true;
                    // console.log(formData.employee_ids);
                    // if preview 
                    
                        axios.post(this.$api_url+'/employee/attendance/summary/report' , {
                        // params: {
                            employee_ids: this.selected.selected,
                            from_date: this.day_one,
                            to_date: this.day_two,
                            is_export: flg,
                        // }
                        }).then(function(response){
                            {                 
                                this.showoverlay = false;
                                console.log('From response recieve');
                                 
                                
                                if(flg == 0)
                                {
                                    this.preview_data = response.data; 
                                    this.is_preview = 1; 
                                    this.is_grid_diplayable = 0;
                                }
                                if(flg == 1)
                                {
                                    // this.is_preview = 1;
                                    console.log('from dowload as an excel');
                                    //window.open(response.data);
                                    console.log(response);
                                    var fileURL = response.data;
                                    
                                    this.downloadFileContent(fileURL);
                                }                                               
                                
                                
                            }}.bind(this)).catch(function (error){ currentObj.serverError(error);});
                    
                    
                     
                }

            },
            download_file(fileURL) 
            {
                if(!this.checkNet()) return false;
                
                var fileName = fileURL.substring(fileURL.lastIndexOf('/')+1);
                if (!window.ActiveXObject) {
                    var save = document.createElement('a');
                    save.href = fileURL;
                    save.target = '_blank';
                    //var filename = fileURL.substring(fileURL.lastIndexOf('/')+1);
                    save.download = fileName || filename;
                    if ( navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) && navigator.userAgent.search("Chrome") < 0) {
                            document.location = save.href;
                        }else{
                            var evt = new MouseEvent('click', {
                                'view': window,
                                'bubbles': true,
                                'cancelable': false
                            });
                            save.dispatchEvent(evt);
                            (window.URL || window.webkitURL).revokeObjectURL(save.href);
                        }    
                }
                else if ( !! window.ActiveXObject && document.execCommand)     {
                    var _window = window.open(fileURL, '_blank');
                    _window.document.close();
                    _window.document.execCommand('SaveAs', true, fileName || fileURL)
                    _window.close();
                }
            }, 
        
        },
        created: function(){
            
            /* fetchin the default list  with employee data */

            this.getCustomList();
        
        }
    }
</script>
